import $ from 'jquery';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

/* jshint camelcase:false */
// eslint-disable-next-line no-undef
Sys.WebForms.PageRequestManager.getInstance().add_endRequest(bindControls);
/* jshint camelcase:true */

bindControls();

function bindControls() {
  $(document).ready(() => {
    const $links = $('.js-modal-open');
    const $panel = $('.js-modal');
    const $closeButton = $('.js-modal-close');
    const $body = $('body');
    const $termsArea = $('.js-terms-conditions');
    const $termsCheckBox = $('.js-terms-checkbox');
    const $termsBtn = $('.js-terms-btn');

    const FIXED = 'is-fixed';

    $links.each((index, elem) => {
      $(elem).on('click', e => {
        e.preventDefault();
        $panel.show();
        $body.addClass(FIXED);
        disableBodyScroll($panel);
      });
    });

    $closeButton.on('click', () => {
      clearAllBodyScrollLocks();
      $panel.hide();
      $body.removeClass(FIXED);
    });

    $termsArea.on('scroll', function() {
      if ($(this).scrollTop() + 1 >= $(this)[0].scrollHeight - $(this).height()) {
        $termsCheckBox.removeAttr('disabled');
        $termsBtn.removeAttr('disabled');
      }
    });

    $termsBtn.on('click', e => {
      e.preventDefault();
      e.stopImmediatePropagation();

      const submitButton = document.querySelector('.js-submit-button');
      if (submitButton) {
        submitButton.click();
      }
    });
  });
}
